module.exports = __webpack_public_path__ + "static/media/right-doble-arow.7d38e3f7.svg";